import { useState, useEffect } from 'react';
import { providersApi, ProviderOverviewStats } from '../services/providers';

export const useProviderStats = () => {
  const [stats, setStats] = useState<ProviderOverviewStats | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        setLoading(true);
        const data = await providersApi.getMyOverviewStats();
        setStats(data);
        setError(null);
      } catch (err: unknown) {
        const resp = (err as { response?: { status?: number; data?: unknown } }).response;
        if (resp?.status === 404) {
          setStats({
            endorsements_received: 0,
            endorsements_given: 0,
            endorsed_by_top_scorers: 0,
          });
        } else {
          const msg = (err as { message?: string }).message;
          setError(msg || 'Failed to fetch provider statistics');
          console.error('Error fetching provider stats:', err);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  return { stats, loading, error };
};
